import { render, staticRenderFns } from "./IrisTextfieldDate.vue?vue&type=template&id=74369f63&"
import script from "./IrisTextfieldDate.vue?vue&type=script&lang=ts&"
export * from "./IrisTextfieldDate.vue?vue&type=script&lang=ts&"
import style0 from "./IrisTextfieldDate.vue?vue&type=style&index=0&id=74369f63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports